module.exports = __webpack_public_path__ + "img/bnr_interview.5ca0ab74.png";